import { Button, ButtonGroup, Checkbox, Col, ControlLabel, Row } from "react-bootstrap";
import { handleFieldChange, handleGroupByChange } from "../../Utils";
import { PARAMS_NAME } from "../BidderV2/config";

import React from 'react';

import SelectWrap from "../../components/SelectWrap";
import FieldGroup from "../../components/FieldGroup";
import Container from "../../components/Container";
import Heading from "../../components/Heading";
import Table from '../../components/StatsTable';

import API from "../../services/API";

import countries from "../../data/countries";

class BidderClickUrlsHourly extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            filtered_report: {
                headers: [],
                data: [],
            },
            report: {
                headers: [],
                data: [],
            },
            values: {
                affid: [],
                subid: [],
                country: [],
                plugin: [],
                source: [],
            },
            filters: {
                affid: [],
                subid: [],
                country: [],
                plugin: [],
                source: [],
            },
            group_by: [],
        }

        this.handleGroupByChange = handleGroupByChange.bind(this);
        this.handleFieldChange = handleFieldChange.bind(this);
        this.on_load_subid = this.on_load_subid.bind(this);
        this.on_search = this.on_search.bind(this);
        this.on_load = this.on_load.bind(this);
    }

    componentDidMount() {
        (async () => {
            const state = this.state;

            const values = await Promise.all([
                API.BidderClickUrlsHourly.distinct('affid'),
                API.BidderClickUrlsHourly.distinct('plugin'),
                API.BidderClickUrlsHourly.distinct('source'),
            ])

            state.values.affid = values[0];
            state.values.plugin = values[1];
            state.values.source = values[2];
            state.loading = false;

            this.setState(state);
        })()
    }

    async on_load_subid() {
        this.setState({ ...this.state, loading: true });

        const state = this.state;

        state.values.subid = await API.BidderClickUrlsHourly.distinct('subid', state.filters);

        state.loading = false;

        this.setState(state);
    }

    async on_load() {
        if (!this.state.group_by.length) return alert('Please select at least one group_by param');

        this.setState({ ...this.state, loading: true });

        const state = this.state;

        state.report = state.filtered_report = await API.BidderClickUrlsHourly.get(state.filters, state.group_by);

        state.loading = false;

        this.setState(state);
    }

    on_search(event) {
        const report = JSON.parse(JSON.stringify(this.state.report));

        if (event.target.value) {
            report.data = report.data.filter((x) => JSON.stringify(x).includes(event.target.value));
        }

        this.setState({ filtered_report: report });
    }

    render() {
        return (
            <Container loading={this.state.loading}>
                <Heading title="Bidder Click URL Hourly"/>

                <Row>
                    <Col lg={12}>
                        <ControlLabel>Group By:</ControlLabel>

                        <Checkbox onChange={this.handleGroupByChange} name="timestamp">Datetime</Checkbox>
                        <Checkbox onChange={this.handleGroupByChange} name="source">Source</Checkbox>
                        <Checkbox onChange={this.handleGroupByChange} name="affid">Affid</Checkbox>
                        <Checkbox onChange={this.handleGroupByChange} name="subid">Subid</Checkbox>
                        <Checkbox onChange={this.handleGroupByChange} name="country">Country</Checkbox>
                        <Checkbox onChange={this.handleGroupByChange} name="plugin">Plugin</Checkbox>
                    </Col>
                </Row>

                <Row>
                    <Col lg={4}>
                        <FieldGroup
                            type="date"
                            name="filters.timestamp_gt"
                            label="Date From:"
                            onChange={this.handleFieldChange}
                            timestamp={"true"}
                        />
                    </Col>

                    <Col lg={4}>
                        <FieldGroup
                            type="date"
                            name="filters.timestamp_lt"
                            label="Date To:"
                            onChange={this.handleFieldChange}
                            timestamp={"true"}
                        />
                    </Col>
                </Row>

                <Row>
                    <Col lg={3}>
                        <SelectWrap
                            values={this.state.values.affid}
                            label="Affid:"
                            name="filters.affid"
                            onChange={this.handleFieldChange}
                            value={this.state.filters.affid}
                            multi
                        />
                    </Col>

                    <Col lg={3}>
                        <SelectWrap
                            values={this.state.values.subid}
                            label="Subid:"
                            name="filters.subid"
                            onChange={this.handleFieldChange}
                            value={this.state.filters.subid}
                            multi
                        />
                    </Col>

                    <Col lg={3}>
                        <SelectWrap
                            values={Object.keys(countries)}
                            label="Country:"
                            name="filters.country"
                            onChange={this.handleFieldChange}
                            value={this.state.filters.country}
                            multi
                        />
                    </Col>

                    <Col lg={3}>
                        <SelectWrap
                            values={this.state.values.plugin}
                            label="Plugin:"
                            name="filters.plugin"
                            onChange={this.handleFieldChange}
                            value={this.state.filters.plugin}
                            multi
                        />
                    </Col>

                    <Col lg={3}>
                        <SelectWrap
                            values={this.state.values.source}
                            label="Source:"
                            name="filters.source"
                            onChange={this.handleFieldChange}
                            value={this.state.filters.source}
                            multi
                        />
                    </Col>
                </Row>

                <Row style={{ marginBottom: '15px' }}>
                    <Col lg={12}>
                        <FieldGroup
                            disabled={!this.state.report.data.length}
                            type="text"
                            name="search"
                            label="Search:"
                            onChange={this.on_search}
                        />
                    </Col>
                </Row>

                <Row style={{ marginBottom: '15px' }}>
                    <Col lg={12}>
                        <ButtonGroup style={{marginRight: '10px'}}>
                            <Button bsStyle="primary" onClick={this.on_load_subid} disabled={!this.state.filters.affid.length}>Load Subid</Button>
                        </ButtonGroup>

                        <Button bsStyle="primary" onClick={this.on_load}>Load</Button>
                    </Col>
                </Row>

                <Table
                    params={this.state.filtered_report.headers}
                    paramsObj={this.state.filtered_report.headers.reduce((object, header) => (object[header] = 1, object), {})}
                    report={this.state.filtered_report.data}
                    total={{}}
                    paramNames={PARAMS_NAME}
                    unixParams={{ timestamp: 1 }}
                    NaNParams={this.state.filtered_report.headers.reduce((object, header) => (object[header] = 1, object), {})}
                />

            </Container>
        )
    }
}

export default BidderClickUrlsHourly;



// WEBPACK FOOTER //
// ./src/scenes/BidderClickUrlsHourly/index.js